import React, { useState } from "react";
import { ExternalLink, Phone, Loader2 } from "lucide-react";
import { BRAND } from "../mock";

// Official OpenTable embeddable reservation widget (canvas endpoint used by their loader).
const OT_CANVAS =
  "https://www.opentable.com/widget/reservation/canvas?rid=1387903&type=standard&theme=standard&iframe=true&overlay=false&domain=com&lang=en-US&ot_source=Restaurant%20website";

export default function OpenTableWidget({ height = 500 }) {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="w-full">
      <div className="relative w-full bg-white rounded-md overflow-hidden" style={{ minHeight: height }}>
        {!loaded && (
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 text-nala-maroon">
            <Loader2 size={26} className="animate-spin" />
            <p className="text-sm tracking-wide-lux uppercase">Loading OpenTable…</p>
          </div>
        )}
        <iframe
          title="OpenTable Reservation"
          src={OT_CANVAS}
          className="w-full relative z-[1]"
          style={{ height, border: "none" }}
          loading="eager"
          onLoad={() => setLoaded(true)}
        />
      </div>

      {/* Fallback — always available */}
      <div className="mt-4 flex flex-col sm:flex-row items-center justify-center gap-3 text-center">
        <a
          href={BRAND.reservationUrl}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 text-nala-maroon text-xs uppercase tracking-[0.16em] font-semibold hover:text-nala-maroon-light transition-colors"
        >
          Open OpenTable in a new tab <ExternalLink size={13} />
        </a>
        <span className="hidden sm:inline text-nala-charcoal/30">·</span>
        <a href={BRAND.phoneHref} className="inline-flex items-center gap-1.5 text-nala-charcoal/70 text-xs hover:text-nala-maroon transition-colors">
          <Phone size={12} /> {BRAND.phone}
        </a>
      </div>
    </div>
  );
}
